import { NavigateWithThread, FocusDashboard, ProfilePage } from '@yeshuman/sdk'
import { Routes, Route } from 'react-router-dom'
import { PatientsPage, PractitionerConsultationsPage } from '../components'

interface PractitionerRoutesProps {
  onStartConversation?: (message: string) => void
}

export function PractitionerRoutes({ onStartConversation }: PractitionerRoutesProps) {
  return (
    <Routes>
      <Route
        index
        element={
          <FocusDashboard
            focus="practitioner"
            onStartConversation={onStartConversation}
          />
        }
      />
      <Route path="profile" element={<ProfilePage />} />
      <Route path="health/patients" element={<PatientsPage />} />
      <Route path="health/consultations" element={<PractitionerConsultationsPage />} />
      {/* Add more practitioner-specific routes here as needed */}
      <Route path="*" element={<NavigateWithThread to="" />} />
    </Routes>
  )
}

